import { ApplicationContext } from '@upside/spa-shared-context';

import { appHeaderAppName, paths } from 'shell/const';
import { getAppStatus, registerApplication, LifeCycles } from 'single-spa';

/**
 * List of paths where the app header should not be shown
 */
const PATHS_WITHOUT_APP_HEADER = [
  `/${paths.VERIFY_MANAGED_SUBSCRIPTION}`,
  `/${paths.CASHFLOW}`,
];

/**
 * Registers appheader if the local storage feature flag globalheader is not set
 */
export const registerAppHeader = (context: ApplicationContext): void => {
  if (!getAppStatus(appHeaderAppName)) {
    registerApplication({
      activeWhen: ({ pathname }) =>
        context.authentication.loggedIn &&
        !PATHS_WITHOUT_APP_HEADER.some((path) => pathname.startsWith(path)),
      app: () => System.import(appHeaderAppName) as Promise<LifeCycles>,
      name: appHeaderAppName,
      customProps: {
        context,
        domElementGetter: () => document.querySelector('#app-header'),
      },
    });
  }
};
